import React from 'react';
import Props from '../../Components/Props';
import FormikFields from 'components/FormikFields';
import JSXCode from '../../Components/JSXCode';
import { Form, Formik } from 'formik';

const TabRadio = (props) => {
  //! State

  //! Function

  //! Render
  return (
    <div className='component:TabRadio'>
      <Formik initialValues={{ game: 'lol' }} onSubmit={() => {}}>
        {({ values }) => {
          return (
            <Form>
              <code className='tw-block tw-mb-3'>{JSON.stringify(values)}</code>

              <div className='tw-flex tw-gap-4'>
                <FormikFields.Radio name='game' id='game-1' label='LOL' valueRadio='lol' />
                <FormikFields.Radio name='game' id='game-2' label='Dota 2' valueRadio='dota2' />
              </div>
            </Form>
          );
        }}
      </Formik>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<Formik initialValues={{ isDeveloper: false }} onSubmit={() => {}}>
{() => {
    return (
    <Form>
        <code className='tw-block tw-mb-3'>{JSON.stringify(values)}</code>

        <div className='tw-flex tw-gap-4'>
            <FormikFields.Radio name='game' id='game-1' label='LOL' valueRadio='lol' />
            <FormikFields.Radio name='game' id='game-2' label='Dota 2' valueRadio='dota2' />
        </div>
    </Form>
    );
}}
</Formik>
`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'id',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'name',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'label',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'afterOnChange',
            type: '(value) => void',
            default: 'undefined',
          },
          { prop: 'classNameContainer', type: 'string', default: 'undefined' },
          { prop: 'positionLabel', type: '"left" | "right"', default: '"left"' },
          {
            prop: 'disabled',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'valueRadio',
            type: '"string" | "number"',
            default: 'undefined',
          },
          {
            prop: 'checked',
            type: 'boolean',
            default: 'false',
          },
        ]}
      />
    </div>
  );
};

export default TabRadio;
